<script setup lang="ts">
import { cardActions } from "@/action/cardActions";
import { action } from "@/components/action/action";
import IconButton from "@/components/ui/IconButton/IconButton.vue";
</script>

<template>
  <IconButton v-bind="action(cardActions.duplicate)" />
</template>
